import { useEffect, useState } from "react";
import api from "@/lib/api";
import { History, Lock } from "lucide-react";

const ACTION_LABEL = {
  creation: "Création", modification: "Modification", suppression: "Suppression",
  enregistrement: "Enregistrement", generation: "Génération", ajout_participant: "Ajout participant",
  modification_participant: "Modification participant", retrait_participant: "Retrait participant",
};

export default function JournalPanel({ operationId, canRead, refreshKey }) {
  const [evts, setEvts] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!canRead) { setErr(true); return; }
    api.get(`/operations/${operationId}/journal`)
      .then((r) => setEvts(r.data)).catch(() => setErr(true));
  }, [operationId, canRead, refreshKey]);

  if (err) return (
    <div className="card" data-testid="journal-panel">
      <div className="notice"><Lock size={14} style={{ marginRight: 6 }} />Accès au journal d'audit réservé aux profils autorisés (HSE, Donneur d'ordre, Auditeur, Administrateur).</div>
    </div>
  );

  const fmt = (iso) => { try { return new Date(iso).toLocaleString("fr-FR"); } catch { return iso; } };

  return (
    <div className="card" data-testid="journal-panel">
      <h3 style={{ fontSize: "1rem", marginBottom: 4, display: "flex", alignItems: "center", gap: 8 }}>
        <History size={16} /> Journal d'audit <span className="tag">append-only</span>
      </h3>
      <p style={{ fontSize: ".82rem", color: "var(--text-muted)", marginBottom: 12 }}>
        Traçabilité non modifiable de toutes les actions (qui, quoi, quand, rôle, origine).
      </p>
      <div className="tablewrap"><table>
        <thead><tr><th>Horodatage</th><th>Acteur</th><th>Rôle</th><th>Action</th><th>Ressource</th><th>Origine</th></tr></thead>
        <tbody>
          {(evts || []).map((e, i) => (
            <tr key={i} data-testid={`journal-row-${i}`}>
              <td className="mono" style={{ fontSize: ".72rem" }}>{fmt(e.timestamp)}</td>
              <td>{e.actorName || e.actorId}</td>
              <td><span className="tag">{e.actorRole}</span></td>
              <td>{ACTION_LABEL[e.action] || e.action}</td>
              <td className="mono" style={{ fontSize: ".72rem" }}>{e.entityType} {e.entityId}</td>
              <td style={{ fontSize: ".72rem", color: "var(--text-muted)" }}>{e.metadata?.source || "—"}{e.typeOperation === "formation" ? " · formation" : ""}</td>
            </tr>
          ))}
          {evts && !evts.length && <tr><td colSpan={6} className="empty">Aucun événement enregistré.</td></tr>}
        </tbody>
      </table></div>
    </div>
  );
}
